module.exports = __webpack_public_path__ + "media/images/screenshot_browse-cae5599bc1111c848d14a35f55e6c1a6.png";